import { useEffect, useState } from "react"
import { ChartContainerLoader } from "../../components/Generic/Charts"
import { useTranslation } from "react-i18next"
import { IInfoIniciativasWS } from "../../interfaces/Workspace"
import { indexIniciativasWS } from "../../api/workspace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons"
import ProjectModal from "../../components/Generic/ProjectModal"
import { useParams } from "react-router"
import Filtros from "./Components/Filtros"
import PieChart from "../../components/Charts/PieChart"
import { ISociosChart } from "../../interfaces/SociosChart"
import { getSociosDataGeneral } from "../../api/sociosChart"

const IniciativaListItem: React.FC<{ iniciativa: IInfoIniciativasWS }> = ({ iniciativa }) => {

    const { t } = useTranslation("translation", { keyPrefix: "iniciativas" });

    const [showModal, setShowModal] = useState<boolean>(false);

    const handleHide = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    return (
        <li className="pb-4 pt-4 border-bottom">
            <div className="row align-items-center">
                <div className="col-md-10">
                    <span className="text-iica-2 text-justify">{iniciativa.descripcion}</span>
                </div>
                <div className="col-md-2">
                    <button className="btn btn-outline-secondary mt-2" onClick={handleShow}>
                        <FontAwesomeIcon
                            icon={faUpRightAndDownLeftFromCenter}
                            className="me-3"
                        />
                        {t("project_list.ver_mas")}
                    </button>
                </div>|
            </div>
            <ProjectModal
                show={showModal}
                crono={iniciativa.cronoICT!}
                subcrono={iniciativa.subCronoICT!}
                hide={handleHide}
            />
        </li>
    );
}

const Iniciativas: React.FC = () => {
    const { t } = useTranslation("translation", { keyPrefix: "iniciativas" });

    const { pageType } = useParams<{ pageType: "contrapartes" | "palabras" }>();

    const [iniciativas, setIniciativas] = useState<IInfoIniciativasWS[]>()
    const [sociosData, setSociosData] = useState<ISociosChart[]>();

    useEffect(() => {
        getSociosDataGeneral().then((res) => {
            setSociosData(res);
            return;
        });
        indexIniciativasWS()
            .then((res) => {
                setIniciativas(res)
            })
        return () => {
            setIniciativas(undefined)
            setSociosData(undefined)
            return
        }
    }, [pageType])

    const filter = (contraparte?: number, palabraClave?: number, busquedaTextual?: string, isArchivo?: number) => {
        indexIniciativasWS({ contraparte: contraparte, clave: palabraClave, text: busquedaTextual, is_archivo: isArchivo })
            .then((res) => {
                setIniciativas(res)
            })
    }

    if (!iniciativas) {
        return (
            <ChartContainerLoader colSize="12" />
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <Filtros filter={filter} pageType={pageType!} colClass="col-12" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {
                    pageType === "contrapartes" ?
                        <PieChart chartName={t("socios")} data={sociosData!} colSize="4" /> : null
                }
                <div className={pageType === "contrapartes" ? `col-8` : `col-12`}>
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-2">
                                <div className="col">
                                    <small>
                                        {t("resultados_ini")} <strong>{iniciativas.length}</strong> {t("resultados_fin")}
                                    </small>
                                </div>
                            </div>
                            <ul
                                className="overflow-y-auto overflow-x-hidden list-unstyled"
                                style={{ maxHeight: "450px" }}
                            >
                                {iniciativas.map((iniciativa, index) => (
                                    <IniciativaListItem key={index} iniciativa={iniciativa} />
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Iniciativas